import { navigateWithParams } from "../../utils/router_utils"

export type AZNavigationState = {
  filter: string
  filter2: string
  query: string
  query2: string
  submit: boolean
}

export const initialAZNavigationState = (
  filter?: string,
  filter2?: string,
  query?: string,
  query2?: string
): AZNavigationState => ({
  filter: filter || '',
  filter2: filter2 || '',
  query: query || '',
  query2: query2 || '',
  submit: false,
})

export const navigateToState = (currentState: AZNavigationState): void => {
  navigateWithParams(window.location.pathname, {
    filter: currentState.filter,
    filter2: currentState.filter2,
    search: currentState.query,
    search2: currentState.query2,
  })
}

export const azNavigationStateUpdaters = {
  updateFilter:
    (filter: string) =>
    (currentState: AZNavigationState): AZNavigationState => ({
      ...currentState,
      filter: filter,
    }),
  updateFilter2:
    (filter2: string) =>
    (currentState: AZNavigationState): AZNavigationState => {
      return {
        ...currentState,
        filter2: filter2,
      }
    },
  updateQuery:
    (query: string) =>
    (currentState: AZNavigationState): AZNavigationState => ({
      ...currentState,
      query: query,
    }),
  updateQuery2:
    (query2: string) =>
    (currentState: AZNavigationState): AZNavigationState => ({
      ...currentState,
      query2: query2,
    }),
  submit: (currentState: AZNavigationState): AZNavigationState => ({
    ...currentState,
    submit: true,
  }),
}
